import { useTranslation } from 'react-i18next';

export default function OutProductionBadge() {
  const { t } = useTranslation('PRODUCTS');

  return (
    <div>
      <span className="inline-flex items-center text-sm font-medium text-gray-700">
        <div className="h-3 w-3 bg-gray-700 mr-2 rounded-full" />
        {t('OUT_PRODUCTION')}
      </span>
    </div>
  );
}
